import React from 'react';

import {ServerIncidents, useLastServerIncidents} from 'features/server';
import LoaderCentered from 'shared/ui/LoaderCentered/LoaderCentered';
import PlugNoIncidents from 'shared/ui/Plugs/PlugNoIncidents/PlugNoIncidents';

import {LAST_INCIDENTS_LIMIT} from '../../../lib/incidentTabs';

const ServerIncidentsTab: React.FC = () => {
    const {pagination, isLoading, isFetching} = useLastServerIncidents(LAST_INCIDENTS_LIMIT);

    return (
        <>
            <LoaderCentered active={isFetching}/>
            <ServerIncidents
                pagination={pagination}
                isLoading={isLoading}
                hidePagination
            />
            {!isLoading && pagination?.items.length === 0 && <PlugNoIncidents size="sm"/>}
        </>
    );
};

export default ServerIncidentsTab;
